import { styled, useTheme } from 'styled-components'

import ItemValidationMessage from './ItemValidationMessage'
import Tooltip from './LocalTooltip'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-bottom: 12px;
`
const Label = styled.label`
  display: block;
  padding: 0 12px 4px;
  color: ${(p) => p.theme.labelText};
  font-size: 12px;
  font-weight: bold;
`

const Note = styled.div`
  padding: 4px 12px 0;
  color: ${(p) => p.theme.mutedText};
  font-size: 12px;
  font-style: italic;
`

const Required = styled.span`
  padding-left: 2px;
  vertical-align: super;
  color: ${(p) => p.theme.highlight};
  font-size: 0.9em;
`

const ContentsWrapper = styled.div`
  display: flex;
  position: relative;
  flex: 1 1 auto;
  flex-direction: column;
`

const MessageWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 8px;
`

// const asterisks = '*✹✸✷✶✵✳︎﹡＊⩮❊❉✻✲⊛＊﹡'

const ItemLabel = ({ label, required, note, meta, children, tooltip }) => {
  const theme = useTheme()
  const labelSuffix = required && <Required>✲</Required>

  return (
    <Wrapper>
      {label && (
        <Label>
          {label}
          {labelSuffix}{' '}
          {tooltip && (
            <Tooltip
              animation='shift-away'
              backgroundColor={theme.background}
              content={tooltip}
              width={500}
            />
          )}
        </Label>
      )}
      <ContentsWrapper>
        {children}
        <MessageWrapper>
          <ItemValidationMessage meta={meta} />
        </MessageWrapper>
      </ContentsWrapper>
      {note && <Note>{note}</Note>}
    </Wrapper>
  )
}

export default ItemLabel
